<template>
  <div id="app">
    <el-container style="padding-bottom: 20px" v-if="$route.name !== 'login'">
      <el-header height="90px">
        <span class="title">后台管理系统</span>

        <el-dropdown @command="handleCommand">
          <div class="user">
            <svg-icon icon-class="user" />
            <span class="name">{{
              $store.state.userInfo && $store.state.userInfo.userEntity.username
            }}</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="psw">修改密码</el-dropdown-item>
            <el-dropdown-item command="out">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-container>
        <el-aside width="260px">
          <el-menu :router="true" :default-active="$route.fullPath">
            <el-menu-item
              :index="item.path"
              v-for="(item, index) in nav"
              :key="index"
            >
              <div slot="title">
                <svg-icon :icon-class="item.icon" />
                {{ item.name }}
              </div>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <router-view v-else></router-view>

    <el-dialog
      :visible.sync="passwordShow"
      :close-on-click-modal="false"
      custom-class="user_data_popup"
      @closed="passwordClose"
    >
      <h2 class="popup_title">修改密码</h2>
      <el-form
        ref="passwordForm"
        size="small"
        label-position="top"
        :model="passwordForm"
        :rules="rules"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            v-model="passwordForm.oldPassword"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input
            type="password"
            v-model="passwordForm.pass"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password">
          <el-input
            type="password"
            v-model="passwordForm.password"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="popup_footer">
        <el-button @click="passwordSubmit" type="primary" size="mini"
          >保存</el-button
        >
        <el-button @click="passwordShow = false" size="mini">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getToken, setToken, removeToken } from "./utils/auth";
export default {
  data() {
    //表单校验规则
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码最少为6位"));
      } else if (value.length > 32) {
        callback(new Error("密码最多为32位"));
      } else {
        if (this.passwordForm.checkPass !== "") {
          this.$refs.passwordForm.validateField("checkPass");
        }
        callback();
      }
    }; //新密码
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    }; //确认密码
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请旧输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码最少为6位"));
      } else if (value.length > 32) {
        callback(new Error("密码最多为32位"));
      } else {
        callback();
      }
    }; //旧密码
    return {
      nav: [], //导航栏.
      passwordShow: false, //修改密码弹窗显示
      passwordForm: {
        //修改密码表单
        pass: "", //新密码
        password: "", //确认密码
        oldPassword: "", //旧密码
        username: "", //用户名
      },
      rules: {
        //表单校验
        pass: [{ validator: validatePass, required: true, trigger: "blur" }],
        password: [
          { validator: validatePass2, required: true, trigger: "blur" },
        ],
        oldPassword: [
          { validator: validatePass3, required: true, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    //监听用户权限字段展示路由
    "$store.state.userInfo.objectName": {
      handler(val) {
        let nav = [
          {
            name: "订单管理",
            path: "/order",
            icon: "order",
          },
          {
            name: "商品管理",
            path: "/goods",
            icon: "goods",
          },
          {
            name: "卡密管理",
            path: "/cardPassword",
            icon: "cardPassword",
          },
          {
            name: "分类管理",
            path: "/classify",
            icon: "classify",
          },
          {
            name: "用户管理",
            path: "/userList",
            icon: "user",
          },
        ];
        if (!val) return;

        let obj = val.split(",");

        this.nav = nav.filter((item) => {
          const itemPath = item.path.replace(/^\//, "");
          if (val === "*") {
            return obj;
          } else {
            return obj.includes(itemPath);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    //用户目录选项
    handleCommand(command) {
      if (command === "psw") {
        this.passwordShow = true;
      } else if (command === "out") {
        removeToken();
        this.$store.commit("logOut");
        this.$router.replace("/login");
      }
    },
    //修改密码
    passwordSubmit() {
      this.$refs["passwordForm"].validate(async (valid) => {
        if (!valid) return;
        await this.$API
          .updatePassword({
            object: {
              oldPassword: this.passwordForm.oldPassword,
              password: this.passwordForm.password,
              username: this.$store.state.userInfo.userEntity.username,
            },
          })
          .then((res) => {
            if (!res) return;
            this.$message.success("修改成功");
            this.passwordShow = false;
          });
      });
    },
    //修改密码框关闭事件
    passwordClose() {
      this.$refs["passwordForm"].resetFields();
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  font-size: 14px;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.el-tooltip__popper {
  max-width: 20%;
}
</style>

<style lang="scss" scoped>
#app {
  height: 100vh;
  display: flex;
  background: #f9f9f9;
}

.el-header {
  background-color: #fff;
  margin-bottom: 20px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 54px 0 40px;

  .title {
    color: #c60525;
    font-size: 28px;
  }

  .user {
    cursor: default;
    .svg-icon {
      font-size: 20px;
      margin-right: 10px;
    }
    .name {
      margin-right: 12px;
    }
  }
}

.el-aside {
  background-color: #fff;
  margin-right: 20px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 0 8px 8px 0;
  padding-top: 76px;
}

.el-menu {
  border: none;
}

.el-menu-item {
  height: 48px;
  line-height: 48px;
  font-size: 20px;
  padding-left: 40px !important;
  .svg-icon {
    font-size: 15px;
    margin-right: 8px;
  }
}

.el-menu-item.is-active {
  color: #fff;
  background-color: #c60525;
}

.el-menu-item:hover {
  background-color: #c60525;
  color: #fff;

  //   background-color: rgba(198, 5, 37, 0.06);
  //   color: #000;
}

.el-main {
  padding: 30px;
  background-color: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-right: 20px;
}

::v-deep .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .user_data_popup {
    margin: 0 !important;
    .el-dialog__body {
      padding: 30px 80px;
    }
  }
}

.popup_title {
  font-size: 20px;
  color: #111111;
  line-height: 28px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #dde0e7;
}

.popup_footer {
  .el-button {
    padding: 7px 48px;
  }
}
::v-deep .el-dialog__footer {
  text-align: left;
  padding: 0 80px 60px;
}
</style>
